(() => {
  const mediaQuery = window.matchMedia('(min-width: 768px)');

  function getSrc(mount) {
    const desktop = mount.dataset.desktopSrc || '';
    const mobile = mount.dataset.mobileSrc || desktop;
    return mediaQuery.matches ? desktop : mobile;
  }

  function initMount(mount) {    
    if (!mount) return;
    
    let video = mount.querySelector('video.hero-video__video');
    if (video) return;

    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplay = mount.dataset.autoplay === 'true' && !prefersReduced;
    const loop = mount.dataset.loop === 'true';
    const mutedSetting = mount.dataset.muted === 'true';

    const src = getSrc(mount);
    if (!src) return;

    video = document.createElement('video');
    video.className = 'hero-video__video';
    video.playsInline = true;
    video.preload = 'none';
    video.muted = mutedSetting || autoplay;
    if (loop) video.loop = true;

    video.addEventListener('loadeddata', () => {
      requestAnimationFrame(() => video.classList.add('is-ready'));
    });

    video.src = src;
    mount.appendChild(video);
    video.load();
    if (autoplay) video.play().catch(() => {});
  }

  function updateMount(mount) {
    const video = mount.querySelector('video.hero-video__video');
    if (!video) return;

    const nextSrc = getSrc(mount);
    if (!nextSrc) return;
   
    const current = video.getAttribute('src') || '';
    if (current === nextSrc) return;

    const wasPlaying = !video.paused;
    const t = video.currentTime || 0;

    video.classList.remove('is-ready');
    video.setAttribute('src', nextSrc);
    video.load();

    video.addEventListener('loadeddata', () => {
      try { video.currentTime = t; } catch (e) {}
      if (wasPlaying) video.play().catch(() => {});
    }, { once: true });
  }

  function runInit() {
    document.querySelectorAll('.hero-video__mount').forEach(initMount);
  }

  function runUpdate() {
    document.querySelectorAll('.hero-video__mount').forEach(updateMount);
  }

  window.addEventListener('load', () => {
    if ('requestIdleCallback' in window) requestIdleCallback(runInit, { timeout: 1500 });
    else setTimeout(runInit, 0);
  });

  // resize debounced + update
  let rt;
  window.addEventListener('resize', () => {
    clearTimeout(rt);
    rt = setTimeout(runUpdate, 200);
  }, { passive: true });
  
  mediaQuery.addEventListener?.('change', runUpdate);
})();
